import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { Popup } from 'components-legacy';

import { Button } from 'components';
import ConfigureSorting from './ConfigureSorting';
import ConfigureVisible from './ConfigureVisible';

export default function ConfigureAttributes({
  filters,
  keys,
  labels,
  setShowConfigurator,
  setVisibleAttributes,
  sortableKeys,
  sortableKeysLabels,
  updateFilters,
  visibleAttributes
}) {
  const t = useTranslations();

  const [renderKeys, setRenderKeys] = useState(visibleAttributes),
    [sorting, setSorting] = useState(filters);

  const allRenderKeysDisabled = Object.values(renderKeys).every((value) => value === false);

  const send = (e) => {
    e.preventDefault();
    close();
    setVisibleAttributes(renderKeys);
    if (sortableKeys) updateFilters(sorting);
  };

  const close = (e) => {
    if (e) e.preventDefault();
    setShowConfigurator();
  };

  return (
    <Popup wrapperCallback={close}>
      <form onSubmit={send}>
        <div>
          <ConfigureSorting {...{ sorting, setSorting, sortableKeys, sortableKeysLabels }} />
          <ConfigureVisible {...{ keys, renderKeys, setRenderKeys, labels }} />

          <div className="flex justify-end">
            <Button size="medium" label={t('transactions.cancel')} variant="text" onClick={close} />
            <Button
              label={t('transactions.apply')}
              size="medium"
              className="flex items-center"
              variant="contained"
              type="submit"
              disabled={allRenderKeysDisabled}
            />
          </div>
        </div>
      </form>
    </Popup>
  );
}
